var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#F4F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.5C10.8579 22.5 7.5 19.1421 7.5 15C7.5 10.8579 10.8579 7.5 15 7.5C19.1421 7.5 22.5 10.8579 22.5 15C22.5 19.1421 19.1421 22.5 15 22.5ZM15 21C18.3137 21 21 18.3137 21 15C21 11.6863 18.3137 9 15 9C11.6863 9 9 11.6863 9 15C9 18.3137 11.6863 21 15 21ZM14.25 17.25H15.75V18.75H14.25V17.25ZM15.75 16.0163V16.5H14.25V15.375C14.25 14.9608 14.5858 14.625 15 14.625C15.6213 14.625 16.125 14.1213 16.125 13.5C16.125 12.8787 15.6213 12.375 15 12.375C14.4542 12.375 13.9992 12.7637 13.8966 13.2793L12.4255 12.9851C12.6648 11.7819 13.7265 10.875 15 10.875C16.4497 10.875 17.625 12.0503 17.625 13.5C17.625 14.6891 16.8343 15.6936 15.75 16.0163Z",
    fill: "#E60A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.b28a61bc0a5d5df89f4fac785f29be98.svg";
export { ForwardRef as ReactComponent };